/**
 * BrewNectar Compare Bottom CTA — fade-up
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(root) {
    var animated = root.querySelectorAll('.bn-cbc__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = root.getAttribute('data-bn-cbc-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bnCbcInit === 'true') return;
    root.dataset.bnCbcInit = 'true';
    initFadeUp(root);
  }

  function initAll() {
    document.querySelectorAll('.bn-cbc').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.bn-cbc');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.bn-cbc');
    if (root) delete root.dataset.bnCbcInit;
  });
})();
